import { api } from "../../api";
import { toast } from "react-toastify";

const PayService = () => {
  const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
  const route = api(root);
  const token = JSON.parse(localStorage.getItem("user"))?.userToken;

  return {
    async GetEmployeeRenumeration({ year }) {
      try {
        let { data } = await route.get(
          `/payroll/getemployeerenumeration?Year=${year}`,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        return data;
      } catch (err) {
        console.log(err);
      }
    },

    async GetPayrollDashboard(params) {
      try {
        let { data } = await route.get(`/Payroll/EmployeePayrollDashboard`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            year: params.year,
            month: params.month,
            PageSize: params.pageSize,
            PageNumber: params.currentPage,
          },
        });

        return data;
      } catch (err) {
        console.log(err);
      }
    },

    GetRenumerationBreakdown: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return route.get(`/payroll/renumerationbreakdown${params}`, data);
    },

    SendPaymentToFinance: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return route.post(`/PayrollPayment`, data);
    },

    declinePaymentToFinance: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return route.post(`/PayrollPayment/decline`, data);
    },

    SendPaymentToFinancePaymentRequisition: function (data) {
      let params = "?";
      for (let [key, value] of Object.entries(data)) {
        params = params + `${key}=${value}&`;
      }
      params = params.replace(/^&/, "");
      return route.post(`/Transaction`, data);
    },
  };
};

export const PayrollService = {
  PayService: PayService,
};
